import { useContext } from 'react';
import DeepLinksContext from '@/contexts/deep-links';

const useDeepLinks = () => {
  const value = useContext(DeepLinksContext);

  return value;
};

export default useDeepLinks;